import React from "react";
import { Checkbox, Divider } from "antd";
import { FiTruck, FiCalendar, FiClock, FiMapPin } from "react-icons/fi";

const PickupOptions = ({ formik, dateOptions, timeSlots, isDarkMode }) => (
  <div className="space-y-4">
    <h2
      className={`text-md font-semibold flex items-center gap-2 ${isDarkMode ? "text-gray-200" : "text-gray-700"}`}
    >
      <FiMapPin size={18} className="text-green-500" />
      Please select your preferable pickup date
    </h2>
    <Divider
      className={`my-2 ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
    />

    <div>
      <div
        className={`flex items-center justify-between p-4 rounded-lg border-2 transition-all cursor-pointer ${
          formik.values.isExpress
            ? `border-green-500 ${isDarkMode ? "" : "bg-green-100"}`
            : isDarkMode
              ? "border-gray-700 hover:border-gray-600"
              : "border-gray-200 hover:border-gray-300"
        }`}
        onClick={() => {
          formik.setFieldValue("isExpress", !formik.values.isExpress);
          if (!formik.values.isExpress) {
            formik.setFieldValue("opd", null);
            formik.setFieldValue("slot", null);
          }
        }}
      >
        <div className="flex items-center gap-3">
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center ${formik.values.isExpress ? "bg-green-500" : isDarkMode ? "bg-gray-700" : "bg-gray-100"}`}
          >
            <FiTruck
              className={
                formik.values.isExpress ? "text-white" : "text-green-500"
              }
              size={18}
            />
          </div>
          <div>
            <span
              className={`text-sm font-medium ${isDarkMode ? "text-gray-200" : "text-gray-700"}`}
            >
              Express Pickup
            </span>
            <p className="text-xs text-gray-400">Pickup within 2 hours</p>
          </div>
        </div>
        <Checkbox
          checked={formik.values.isExpress}
          onChange={(e) => {
            e.stopPropagation();
            formik.setFieldValue("isExpress", e.target.checked);
            if (e.target.checked) {
              formik.setFieldValue("opd", null);
              formik.setFieldValue("slot", null);
            }
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>

    {!formik.values.isExpress && (
      <>
        {/* Date Selection - Square Boxes */}
        <div>
          <label
            className={`block text-xs font-medium mb-2 ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}
          >
            <FiCalendar className="inline mr-1" size={12} />
            Select Date *
          </label>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            {dateOptions.map((date) => (
              <div
                key={date.value}
                className={`cursor-pointer transition-all`}
                onClick={() => formik.setFieldValue("opd", date.value)}
              >
                <div
                  className={`p-3 rounded-lg border-2 text-center transition-all ${
                    formik.values.opd === date.value
                      ? "border-green-500 bg-green-50 "
                      : isDarkMode
                      ? "border-gray-700 hover:border-gray-500 bg-gray-800"
                      : "border-gray-200 hover:border-gray-300 bg-white"
                  }`}
                >
                  <div
                    className={`text-xs font-medium ${
                      formik.values.opd === date.value
                        ? "text-green-600 "
                        : isDarkMode
                        ? "text-gray-400"
                        : "text-gray-500"
                    }`}
                  >
                    {date.label.split(",")[0]}
                  </div>
                  <div
                    className={`text-lg font-bold mt-1 ${
                      formik.values.opd === date.value
                        ? "text-green-700 "
                        : isDarkMode
                        ? "text-white"
                        : "text-gray-900"
                    }`}
                  >
                    {date.label.split(",")[1]?.trim() || date.label.split(" ")[1]}
                  </div>
                  <div
                    className={`text-xs mt-1 ${
                      formik.values.opd === date.value
                        ? "text-green-600 "
                        : isDarkMode
                        ? "text-gray-500"
                        : "text-gray-400"
                    }`}
                  >
                    {date.label.split(",")[2]?.trim() || ""}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {formik.touched.opd && formik.errors.opd && (
            <div className="mt-2 text-xs text-red-500">{formik.errors.opd}</div>
          )}
        </div>

        {/* Time Slot Selection */}
        <div>
          <label
            className={`block text-xs font-medium mb-2 ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}
          >
            <FiClock className="inline mr-1" size={12} />
            Select Time Slot *
          </label>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {timeSlots.map((slot) => (
              <div
                key={slot.value}
                className={`cursor-pointer transition-all`}
                onClick={() => formik.setFieldValue("slot", slot.value)}
              >
                <div
                  className={`flex items-center justify-center gap-2 p-3 rounded-lg border-2 transition-all ${
                    formik.values.slot === slot.value
                      ? "border-green-500 bg-green-50 "
                      : isDarkMode
                      ? "border-gray-700 hover:border-gray-500 bg-gray-800"
                      : "border-gray-200 hover:border-gray-300 bg-white"
                  }`}
                >
                  {slot.icon}
                  <span
                    className={`text-sm font-medium ${
                      formik.values.slot === slot.value
                        ? "text-green-700 "
                        : isDarkMode
                        ? "text-gray-300"
                        : "text-gray-700"
                    }`}
                  >
                    {slot.label}
                  </span>
                </div>
              </div>
            ))}
          </div>
          {formik.touched.slot && formik.errors.slot && (
            <div className="mt-2 text-xs text-red-500">
              {formik.errors.slot}
            </div>
          )}
        </div>
      </>
    )}
  </div>
);

export default PickupOptions;